import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from './list.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import ReactUtils from '../../packages/react-utils/react-utils.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var List = function (_a) {
  var appearance = _a.appearance,
    extraClasses = _a.extraClasses,
    children = _a.children,
    rest = __rest(_a, ["appearance", "extraClasses", "children"]);
  // initializes classname depending on appearance as we import both scss partials
  var cssClass = appearance ? "list-".concat(appearance) : 'list';
  var bem = HoneyBem.init(cssClass, styles);
  // switch type of list depending on appearance
  var ListType = appearance === 'numbered' ? 'ol' : 'ul';
  return /*#__PURE__*/React__default__default.createElement(ListType, __assign({
    className: bem.b(false, extraClasses)
  }, rest), ReactUtils.mapRecursively(children, function (child) {
    return /*#__PURE__*/React__default__default.isValidElement(child) && /*#__PURE__*/React__default__default.cloneElement(child, {
      className: bem.e('item')
    });
  }));
};
List.displayName = 'List';
List.defaultProps = {
  appearance: null,
  extraClasses: ''
};
List.propTypes = {
  appearance: PropTypes__default.oneOf(['numbered']),
  extraClasses: PropTypes__default.string,
  children: function (props) {
    var error = null;
    if (!props.children) {
      error = new Error('"List" requires one or more "li" elements as "children".');
    }
    React__default__default.Children.forEach(props.children, function (child) {
      var htmlChild = child;
      if (htmlChild !== null && htmlChild.type !== 'li') {
        error = new Error("\"List\" accepts only \"li\" elements as \"children\" but received \"".concat(htmlChild.type, "\"."));
      }
    });
    return error;
  }
};
var list = Injecss(List, styles);

export { List, list as default };
